<template>
  <div>
    <headerSection :mainMenu="mainMenu"></headerSection>

    <!-- Running Text Section -->
    <RunningText
      text="เว็บตรง ไม่ล็อคยูส ฝาก-ถอน โอนไว 5 วินาที ไม่มีขั้นต่ำ ไม่ติดเทิร์น ไม่จำกัดการถอน คืนยอดเสีย 5% เเนะนำเพื่อนรับเพิ่ม 3% แอดมินบริการ 24 ชั่วโมง"
      extraClasses="home-style"
    />

    <!-- Main Layout Container -->
    <div class="main-layout">
      <!-- Desktop Layout -->
      <div class="desktop-layout desktop-only">
        <!-- Left Sidebar -->
        <LeftSidebar
          :leftMenuItems="leftMenuItems"
          :hoveredIndex="hoveredLeftIndex"
          :user="user"
          @menu-enter="onLeftMenuEnter"
          @menu-leave="onLeftMenuLeave"
        />

        <!-- Main Content Area -->
        <div class="main-content">
          <!-- Event Cover Section -->
          <div class="x-cover x-index-event-container" style="padding-top: 0px;">
            <img src="../assets/images/cover-minigame-bg.jpg" class="-bg" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง PHENIX789">
            <img src="../assets/images/cover-minigame-bg-mobile.jpg" class="-bg -mobile" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง PHENIX789">

            <div class="container-fluid">
              <div class="row -contents-wrapper">
                <div class="col-12 col-md-6 -left-content"></div>
                <div class="col-12 col-md-6 -right-content bg-mobile">
                  <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                    <div class="slick-list draggable" style="height: 58px;">
                      <div class="slick-track" style="opacity: 1; width: 4495px; top: 5px; display: flex; justify-content: flex-end; float: right;">
                        <div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;">
                          <h1 class="-title">กิจกรรมเพียบ <br> จัดหนัก แรงที่สุดในตอนนี้</h1>
                          <p class="-sub-title">เกมส์เยอะโปรโมชั่นดี อันดับ 1 ของจริง ไม่ใช่ทุกคนที่ทำได้</p>
                          <div class="-btn-wrapper d-none animated fadeInUp" data-animatable="fadeInUp" data-delay="500">
                            <a href="javascript:void(0)" class="btn -register-btn order-0" data-toggle="modal" data-target="#registerModal" tabindex="0">
                              <span class="-btn-title">สมัครสมาชิก</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Menu Bar -->
          <MainMenuBar
            :mainMenuItems="mainMenuItems"
            :hoveredIndex="hoveredMainIndex"
            :user="user"
            @menu-enter="onMainMenuEnter"
            @menu-leave="onMainMenuLeave"
          />

          <!-- Event Content -->
          <div class="content-wrapper">
            <!-- Event Cards Section -->
            <div class="x-event-index-container">
              <div class="container">
                <div class="row -event-row-wrapper">
                  <div class="col-lg-4 col-6 -col-wrapper" v-for="(item,index) in minigames" :key="index">
                    <div class="-card-item animated fadeInUp" data-animatable="fadeInUp" data-delay="200">
                      <a href="javascript:void(0)" class="d-block h-100 -card-link-wrapper" @click="gotoMinigame(item)">
                        <div class="x-card card -multi-card">
                          <div class="-img-container">
                            <img :src="item.logo" :alt="item.name" class="-img">
                          </div>
                          <div class="card-body">
                            <div class="-title-container m-3">
                              <h3 class="-title">{{item.name}}</h3>
                              <p class="-sub-title">{{item.detail}}</p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="mobile-layout mobile-only">
        <!-- Mobile Event Cover Section -->
        <div class="x-cover x-index-event-container mobile-cover" style="padding-top: 63px;">
          <img src="../assets/images/cover-minigame-bg.jpg" class="-bg" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง PHENIX789">
          <img src="../assets/images/cover-minigame-bg-mobile.jpg" class="-bg -mobile" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง PHENIX789">

          <div class="container-fluid">
            <div class="row -contents-wrapper">
              <div class="col-12 col-md-6 -left-content"></div>
              <div class="col-12 col-md-6 -right-content bg-mobile">
                <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                  <div class="slick-list draggable" style="height: 58px;">
                    <div class="slick-track" style="opacity: 1; width: 4495px; top: 5px; display: flex; justify-content: flex-end; float: right;">
                      <div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;">
                        <h1 class="-title">กิจกรรมเพียบ <br> จัดหนัก แรงที่สุดในตอนนี้</h1>
                        <p class="-sub-title">เกมส์เยอะโปรโมชั่นดี อันดับ 1 ของจริง ไม่ใช่ทุกคนที่ทำได้</p>
                        <div class="-btn-wrapper d-none animated fadeInUp" data-animatable="fadeInUp" data-delay="500">
                          <a href="javascript:void(0)" class="btn -register-btn order-0" data-toggle="modal" data-target="#registerModal" tabindex="0">
                            <span class="-btn-title">สมัครสมาชิก</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Main Menu -->
        <MobileMainMenu :mainMenuItems="mainMenuItems" :user="user" />

        <!-- Mobile With Sidebar Layout -->
        <div class="mobile-with-sidebar">
          <!-- Mobile Left Sidebar -->
          <MobileLeftSidebar
            :leftMenuItems="leftMenuItems"
            :hoveredIndex="hoveredLeftIndex"
            :user="user"
            @menu-enter="onLeftMenuEnter"
            @menu-leave="onLeftMenuLeave"
          />

          <!-- Mobile Content Area -->
          <div class="mobile-content">
            <!-- Mobile Event Content -->
            <div class="mobile-content-wrapper">
              <!-- Mobile Event Cards Section -->
              <div class="x-event-index-container">
                <div class="container">
                  <div class="row -event-row-wrapper">
                    <div class="col-lg-4 col-6 -col-wrapper" v-for="(item,index) in minigames" :key="index">
                      <div class="-card-item animated fadeInUp" data-animatable="fadeInUp" data-delay="200">
                        <a href="javascript:void(0)" class="d-block h-100 -card-link-wrapper" @click="gotoMinigame(item)">
                          <div class="x-card card -multi-card">
                            <div class="-img-container">
                              <img :src="item.logo" :alt="item.name" class="-img">
                            </div>
                            <div class="card-body">
                              <div class="-title-container m-3">
                                <h3 class="-title">{{item.name}}</h3>
                                <p class="-sub-title">{{item.detail}}</p>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import router from './../router'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import moment from 'moment-timezone'
const axios = require('axios').default

export default {
  name: 'Event',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    LeftSidebar: () => import('@/components/LeftSidebar.vue'),
    MobileLeftSidebar: () => import('@/components/MobileLeftSidebar.vue'),
    MainMenuBar: () => import('@/components/MainMenuBar.vue'),
    MobileMainMenu: () => import('@/components/MobileMainMenu.vue'),
    RunningText: () => import('@/components/RunningText.vue')
  },
  data() {
    return {
      receiveAnounceMent: false,
      mainMenu: 'event',
      hoveredLeftIndex: null,
      hoveredMainIndex: null,
      leftMenuItems: [
        { name: 'เล่นบ่อย', path: '/main?type=favorite', icon: require('@/assets/images/menu_left/left_1.png'), hoverIcon: require('@/assets/images/menu_left/left_1_hover.png') },
        { name: 'ยอดนิยม', path: '/main?type=popular', icon: require('@/assets/images/menu_left/left_2.png'), hoverIcon: require('@/assets/images/menu_left/left_2_hover.png') },
        { name: 'คาสิโน', path: '/main?type=casino', icon: require('@/assets/images/menu_left/left_3.png'), hoverIcon: require('@/assets/images/menu_left/left_3_hover.png') },
        { name: 'สล็อต', path: '/main?type=slot', icon: require('@/assets/images/menu_left/left_4.png'), hoverIcon: require('@/assets/images/menu_left/left_4_hover.png') },
        { name: 'ยิงปลา', path: '/main?type=fishing', icon: require('@/assets/images/menu_left/left_5.png'), hoverIcon: require('@/assets/images/menu_left/left_5_hover.png') },
        { name: 'กีฬา', path: '/playsport', icon: require('@/assets/images/menu_left/left_6.png'), hoverIcon: require('@/assets/images/menu_left/left_6_hover.png') },
        { name: 'esport', path: '/playesport', icon: require('@/assets/images/menu_left/left_7.png'), hoverIcon: require('@/assets/images/menu_left/left_7_hover.png') },
        { name: 'hilo', path: '/playlotto', icon: require('@/assets/images/menu_left/left_9.png'), hoverIcon: require('@/assets/images/menu_left/left_9_hover.png') }
      ],
      mainMenuItems: [
        { name: 'โปรโมชั่น', path: '/promotion', icon: require('@/assets/images/menu_main/main_menu_1.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_1.png') },
        { name: 'แลกของรางวัล', path: '/rewards', icon: require('@/assets/images/menu_main/main_menu_2.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_2.png') },
        { name: 'คืนยอดเล่น', path: '/cashback', icon: require('@/assets/images/menu_main/main_menu_3.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_3.png') },
        { name: 'สิทธิพิเศษ', path: '/event', icon: require('@/assets/images/menu_main/main_menu_4.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_4.png') },
        { name: 'พันธมิตร', path: '/partner', icon: require('@/assets/images/menu_main/main_menu_5.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_5.png') },
        // { name: 'ฝากต่อเนื่อง', path: '/continue', icon: require('@/assets/images/menu_main/main_menu_6.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_6.png') }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    minigames () {
      return this.$store.state.user.minigames
    },
    sites_credit () {
      return this.$store.state.user.sites_credit
    }
  },
  mounted () {
    this.$store.dispatch('user/getMinigames').catch(err => { console.error(err) })
  },
  methods: {
    // Menu hover methods
    onLeftMenuEnter (index) {
      this.hoveredLeftIndex = index
    },
    onLeftMenuLeave () {
      this.hoveredLeftIndex = null
    },
    onMainMenuEnter (index) {
      this.hoveredMainIndex = index
    },
    onMainMenuLeave () {
      this.hoveredMainIndex = null
    },
    async gotoMinigame (item) {
      if (this.user && this.user.key) {
        if (item.id === '3boxs') {
          router.replace('/boxs')
        } else if (item.id === 'checkin') {
          this.$store.dispatch('user/refreshCreditAll').finally(async (res) => {
            if (item.turn && Number(item.turn) > 0 && this.sites_credit && Number(this.sites_credit.credit) > 5) {
              this.$swal({ icon: 'error', title: 'Error!', text: 'พี่จ๋ามีมีมากกว่า 4 เครดิต ไม่สามารถเล่นได้นะคะ!!!' })
              return false
            }

            if ((item.deposit && this.user.games && Number(this.user.games.checkin) > 0) || item.deposit === '0') {
              await firebase.firestore().collection('spin').doc(`${this.user.key}-${moment().tz('Asia/Bangkok').format('YYYY-MM-DD')}-checkin`).get().then((snapshot) => {
                if (snapshot.exists) {
                  this.$swal({ icon: 'error', title: 'Error!', text: 'ท่าน Check-in วันนี้แล้วนะคะรอพรุ่งนี้นะคะ!!!' })
                } else {
                  axios({
                    method: 'post',
                    url: 'https://phenix.apifast.xyz/qspin/checkin',
                    data: {
                      key: this.user.key,
                      code: this.user.code,
                      value: Number(item.from),
                      type: item.type,
                      cal: (item.cal) ? item.cal : 'manual'
                    }
                  })
                  setTimeout(() => {
                    this.$swal({ icon: 'success', title: 'Success', text: 'ท่าน Check-in เรียบร้อยแล้วค่ะ' })
                  }, 1000)
                }
              })
            } else {
              await firebase.firestore().collection('spin').doc(`${this.user.key}-${moment().tz('Asia/Bangkok').format('YYYY-MM-DD')}-checkin`).get().then((snapshot) => {
                if (snapshot.exists) {
                  this.$swal({ icon: 'error', title: 'Error!', text: 'ท่าน Check-in วันนี้แล้วนะคะรอพรุ่งนี้นะคะ!!!' })
                } else {
                  this.$swal({ icon: 'error', title: 'Error!', text: 'โปรดตรวจสอบสิทธิ์การ Check-in!' })
                }
              })
            }
          }).catch(err => { console.error(err); this.fa_spin = false })
        } else if (item.id === 'code') {
            this.$store.commit('user/SET_LOADING', true)
            this.$store.dispatch('user/refreshCreditAll').finally(async (res) => {
                if (item.turn && Number(item.turn) > 0 && this.sites_credit && Number(this.sites_credit.credit) > 5) {
                    this.$swal({ icon: 'error', title: 'Error!', text: 'พี่จ๋ามีมีมากกว่า 4 เครดิต ไม่สามารถเล่นได้นะคะ!!!' })
                    this.$store.commit('user/SET_LOADING', false)
                    return false
                }
                firebase.firestore().collection('codefree').doc(this.user.key).get().then((result)=>{
                    if(!result.exists){
                        this.$swal({ 
                            title: 'โปรดกรอกรหัส', 
                            input: 'text', 
                            inputAttributes: {
                                autocapitalize: 'off'
                            },
                            showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                            cancelButtonText: 'ยกเลิก',
                            showLoaderOnConfirm: true,
                            preConfirm: async (login) => {
                                if(item.typecode === 'โค้ดซ้ำ' && item.code !== login){
                                    this.$swal({ icon: 'error', title: 'Error!', text: 'โปรดตรวจสอบ Code ค่ะ!!' })
                                    this.$store.commit('user/SET_LOADING', false)
                                }else{
                                    setTimeout(() => {
                                        axios({
                                            method: 'post',
                                            url: 'https://phenix.apifast.xyz/qspin/code',
                                            data: {
                                                key: this.user.key,
                                                code: this.user.code,
                                                keycode: login,
                                            }
                                        });
                                    }, Math.floor(Math.random() * 3000));
                                    return true;
                                }
                            },
                            allowOutsideClick: () => !Swal.isLoading()
                        }).then(() => {
                            this.$store.commit('user/SET_LOADING', false)
                        })
                    }else{
                        this.$store.commit('user/SET_LOADING', false)
                        this.$swal({ icon: 'error', title: 'Error!', text: 'ท่านรับ Code ฟรีไปแล้ว!!' })
                    }
                })
            })
        } else {
          router.replace('/' + item.id)
        }
      }
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/')
      }
    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag =
        is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>'
      return (str + '').replace(
        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        '$1' + breakTag + '$2'
      )
    }
  }
}
</script>

<style scoped>

/* Desktop Layout */
.desktop-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  margin-left: 100px;
  padding-top: 105px;
  width: calc(100% - 100px);
  min-height: 100vh;
  background-image: url('../assets/images/background/desktop.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Ensure x-cover appears above menu */
.main-content .x-cover {
  position: relative;
  z-index: 0;
}

.content-wrapper {
  padding: 20px;
}

/* Mobile Layout */
.mobile-layout {
  display: none;
  padding-top: 105px;
  min-height: 100vh;
  background-image: url('../assets/images/background/mobile.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Mobile cover section positioning */
.mobile-layout .mobile-cover {
  margin-top: -105px;
  padding-top: 105px;
}

.mobile-with-sidebar {
  display: flex;
  min-height: calc(100vh - 300px);
}

.mobile-content-wrapper {
  padding: 10px;
}

/* Mobile x-cover positioning */
.mobile-cover {
  position: relative;
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow: hidden;
}

.mobile-cover .-bg {
  width: 100%;
  height: auto;
  object-fit: cover;
  max-height: 200px;
}

.mobile-cover .-bg.-mobile {
  display: block;
}

.mobile-cover .-bg:not(.-mobile) {
  display: none;
}

.mobile-cover .container-fluid {
  padding: 10px;
}

.mobile-cover .-title {
  font-size: 18px !important;
  line-height: 1.3;
  margin-bottom: 5px;
}

.mobile-cover .-sub-title {
  font-size: 14px !important;
  line-height: 1.2;
}

/* Responsive Utilities */
.desktop-only {
  display: block;
}

.mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }

  .desktop-layout {
    display: none;
  }

  .mobile-layout {
    display: block;
  }
}

@media (max-width: 768px) {
  .mobile-main-menu-item {
    min-width: 40px;
    padding: 6px;
  }
}

/* Existing Event Styles */
/* Mobile responsive adjustments */
@media screen and (max-width: 992px) {
    .resize {
        width: 899px;
    }
}

@media screen and (max-width: 600px) {
    .resize {
        width: 399px;
    }

    .mobile-cover {
        max-height: 250px;
    }

    .mobile-cover .-bg {
        max-height: 150px;
    }

    .mobile-cover .-title {
        font-size: 16px !important;
    }

    .mobile-cover .-sub-title {
        font-size: 12px !important;
    }
}

.bg-mobile2 {
  margin-right: 100px;
}

@media screen and (max-width: 992px) {
    .resize {
        width: 899px;
    }
}

@media screen and (max-width: 600px) {
    .resize {
        width: 399px;
    }
    .bg-mobile {
      background-color: #1c1c1c;
    }
    .bg-mobile2 {
      margin-right: 0;
    }
}
</style>
